import React, { useEffect, useRef } from 'react';
import { useSearchParams, Link, useNavigate } from 'react-router-dom';
import Navigation from './Navigation';

const Releases = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const releaseRefs = useRef({});

  useEffect(() => {
    // Scroll to top on initial load
    window.scrollTo(0, 0);

    // Check for utm_campaign parameter
    const utmCampaign = searchParams.get('utm_campaign');
    
    if (utmCampaign) {
      // Extract version from utm_campaign (e.g., "v1.0.0" from utm_campaign)
      const version = utmCampaign;
      
      // Scroll to the specific release section if it exists
      if (releaseRefs.current[version]) {
        setTimeout(() => {
          releaseRefs.current[version].scrollIntoView({ 
            behavior: 'smooth', 
            block: 'start' 
          });
        }, 100);
      }
    }
  }, [searchParams]);

  return (
    <div className="releases-page">
      <Navigation 
        showDemoButton={false}
        secondaryButtonText="Back to Home"
        onSecondaryClick={() => navigate('/')}
        trackingLocation="releases_page"
      />
      <div className="releases-container">
        <div className="releases-header">
            <h1>Release Notes</h1>
            <p>
                Stay updated with the latest features, improvements, and fixes
            </p>
        </div>

        <div className="releases-content">
            
            <div 
            className="release-section" 
            id="v1.3.0"
            ref={el => releaseRefs.current['v1.3.0'] = el}
            >
                <div className="release-header">
                    <h2>Version 1.3.0</h2>
                    <span className="release-date">February 2026</span>
                </div>
                <div className="release-body">
                    <div className="release-category">
                        <h3>Highlights</h3>
                        <ul>
                            <li>Asset, debt, and cashflow labeling and filtering</li>
                            <li>Improvements to goal card formats</li>
                        </ul>
                    </div>
                </div>
            </div>

            <div 
            className="release-section" 
            id="v1.2.0"
            ref={el => releaseRefs.current['v1.2.0'] = el}
            >
                <div className="release-header">
                    <h2>Version 1.2.0</h2>
                    <span className="release-date">February 2026</span>
                </div>
                <div className="release-body">
                    <div className="release-category">
                        <h3>Highlights</h3>
                        <ul>
                            <li>Added local network sharing data sharing across devices</li>
                        </ul>
                    </div>
                </div>
            </div>

            <div 
            className="release-section" 
            id="v1.1.0"
            ref={el => releaseRefs.current['v1.1.0'] = el}
            >
                <div className="release-header">
                    <h2>Version 1.1.0</h2>
                    <span className="release-date">February 2026</span>
                </div>
                <div className="release-body">
                    <div className="release-category">
                        <h3>Highlights</h3>
                        <ul>
                            <li>Improved net worth goal setting experience</li>
                        </ul>
                    </div>
                </div>
            </div>

            <div 
            className="release-section" 
            id="v1.0.8"
            ref={el => releaseRefs.current['v1.0.8'] = el}
            >
                <div className="release-header">
                    <h2>Version 1.0.8</h2>
                    <span className="release-date">February 2026</span>
                </div>
                <div className="release-body">
                    <div className="release-category">
                        <h3>Highlights</h3>
                        <ul>
                            <li>Improvements to cashflow, debt, and asset management</li>
                            <li>Bug fix in timeline to achieve net worth goals</li>
                            <li>Improvements to goal achievement notifications</li>
                        </ul>
                    </div>
                </div>
            </div>

            <div 
            className="release-section" 
            id="v1.0.7"
            ref={el => releaseRefs.current['v1.0.7'] = el}
            >
                <div className="release-header">
                    <h2>Version 1.0.7</h2>
                    <span className="release-date">October 2025</span>
                </div>
                <div className="release-body">
                    <div className="release-category">
                        <h3>Highlights</h3>
                        <ul>
                            <li>Initial public release of Solidly Finance</li>
                            <li>Comprehensive financial planning tools</li>
                            <li>Secure local data storage with encryption</li>
                            <li>Cross-platform desktop application</li>
                        </ul>
                    </div>
                </div>
            </div>

        {/* Add future releases here following the same pattern */}
        {/* Example for future release:
        <div 
          className="release-section" 
          id="v1.1.0"
          ref={el => releaseRefs.current['v1.1.0'] = el}
        >
          <div className="release-header">
            <h2>Version 1.1.0</h2>
            <span className="release-date">TBD</span>
          </div>
          <div className="release-body">
            <div className="release-category">
              <h3>🎉 New Features</h3>
              <ul>
                <li>Feature 1</li>
                <li>Feature 2</li>
              </ul>
            </div>
            <div className="release-category">
              <h3>🐛 Bug Fixes</h3>
              <ul>
                <li>Fix 1</li>
                <li>Fix 2</li>
              </ul>
            </div>
          </div>
        </div>
        */}
        </div>

        <div className="back-to-home">
          <Link to="/" className="back-link">← Back to Home</Link>
        </div>
      </div>
    </div>
  );
};

export default Releases;
